'use client'

import { CaretLeft, CaretRight } from '@phosphor-icons/react'
import { useState } from 'react'
import ReferenceAvatar from './ReferenceAvatar'

type Reference = {
  quote: string
  name: string
  role: string
  image?: string
  initials?: string
  url?: string
}

const references: Reference[] = [
  {
    quote:
      'Braňo enjoys analytics, especially from a technical perspective. He handles technologies like GTM or SGTM with ease; to implement a new platform on a website, all he needs is a link to the documentation. As a bonus, he also handles project management, which is definitely not common among IT specialists.',
    name: 'Pavel Šabatka',
    role: 'Freelance Web Analyst',
    image: '/pavel.webp',
    url: 'https://www.sabatka.net',
  },
  {
    quote:
      'I worked with Braňo for almost a year and even as a young student he surprised me with his technical skills and level of experience, which was higher than one would expect. Even though web analytics was new for him, I saw very fast progress and a strong willingness to take on new challenges. He may seem like a classic “IT guy”, but he can easily surprise you with his communication and project management skills, which makes him a great partner to work with, whether as a colleague or a freelancer taking care of your project.',
    name: 'Matúš Elias',
    role: 'Digital Analyst | ONEPLAY',
    image: '/matus.webp',
    initials: 'ME',
  },
  {
    quote:
      'From the very beginning, he stood out for his approach to work, his curiosity, and his genuine drive to keep learning and improving. He understands new topics quickly, has a broad technical skill set, and never seems content to simply rely on what he already knows. He is constantly developing his skills and looking for better ways to solve problems. I would especially recommend Branislav for project-based and consulting work. He has the drive to move things forward, takes ownership, and is able to work independently from understanding the problem through to delivering the solution.',
    name: 'Katarína Hlaváčová',
    role: 'Data & Analytics Specialist',
    image: '/katarina-hlavacova.webp',
    initials: 'KH',
  },
]

export default function ClientReferences() {
  const [activeReference, setActiveReference] = useState(0)

  const showPrevious = () => {
    setActiveReference(current => (current - 1 + references.length) % references.length)
  }

  const showNext = () => {
    setActiveReference(current => (current + 1) % references.length)
  }

  return (
    <section className="portfolio-section" aria-labelledby="references-title">
      <div className="portfolio-container">
        <div className="reference-heading-row">
          <h2 id="references-title">Good work starts with trust.</h2>
          <div className="reference-controls" aria-label="Reference navigation">
            <button type="button" onClick={showPrevious} aria-label="Previous reference">
              <CaretLeft aria-hidden="true" />
            </button>
            <button type="button" onClick={showNext} aria-label="Next reference">
              <CaretRight aria-hidden="true" />
            </button>
          </div>
        </div>
        <div className="reference-layout" aria-live="polite">
          {references.map((reference, index) => (
            <figure
              key={reference.name}
              className={index === activeReference ? 'is-active' : undefined}
              aria-hidden={index !== activeReference}
            >
              <blockquote>“{reference.quote}”</blockquote>
              <figcaption>
                <ReferenceAvatar name={reference.name} image={reference.image} initials={reference.initials} />
                <div>
                  {reference.url ? <a href={reference.url} target="_blank" rel="noopener noreferrer" className="font-semibold hover:underline">{reference.name}</a> : <span className="font-semibold">{reference.name}</span>}
                  <p>{reference.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  )
}
